import React from 'react'
import {observer, inject} from 'mobx-react'
import Logger from '../stores/Logger'
import { Glyphicon, Button, Label } from 'react-bootstrap'
import Confirm from 'react-confirm-bootstrap'
import StripeCheckout from 'react-stripe-checkout'
import PricingTable from '../components/PricingTable'
import PricingSlot from '../components/PricingSlot'
import PricingDetail from '../components/PricingDetail'
import '../components/css/PlanGrid.css'
import '../components/css/PlanPage.css'
import './css/Spinner.css'

class PlanPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            didBuy:false,
        }
    }
    onToken(token){
        this.setState({didBuy:true})
        Logger.trackEvent('createSubscription')
        const {authStore} = this.props.stores 
        authStore.storeStripeToken(token)
    }
    cancelPlan(){
        this.setState({didBuy:false})
        Logger.trackEvent('cancelSubscription')
        const {authStore} = this.props.stores 
        //cancel with Stripe is done via cloud function
        authStore.downgradeToLowerPlan('single_user_free')
    }
    onBusiness(e){
        console.log('onBusiness was pressed',e.target)
    }
    render() {
        const {stores} = this.props
        const {authStore} = stores
        const user = authStore.authUser()
        const userProfile = authStore.userProfile()
        var devEnv = true
        if(window.location.host === 'tool.pre.do'){
            devEnv = false
        }

        var onFreePlan = true
        if(userProfile){
            onFreePlan = (userProfile.plan !== 'single_user_paid_private') ? true : false
        }else{ 
            return null // do not render until plan is ready
        }
        if(this.state.didBuy && onFreePlan){
            return (
                <div className='container'>
                    <h1>PRE.DO Plans</h1>
                    <div>
                        <h1><Glyphicon glyph='heart'/><Glyphicon glyph='heart'/><Glyphicon glyph='heart'/> THANK YOU <Glyphicon glyph='heart'/><Glyphicon glyph='heart'/><Glyphicon glyph='heart'/></h1>
                        <h2><span className='glyphicon glyphicon-refresh Spinner'></span>Updating your subscription...</h2>
                    </div>
                </div>                
            )
        }
        let stripeKey = 'pk_test_yI9UZHeOgfQNmSzfJ2MQ77aV'
        if(!devEnv){
            stripeKey = 'pk_live_ZWtR3b5XF3Nbof4OJjMnHC9t'
        }
        return (
            <div className='container'>
                <h1>PRE.DO Plans</h1>

                {devEnv && (
                    <div>
                    <h3>On the <Label bsStyle='primary'>dev-environment</Label> you can test subscription with a test credit card:</h3>
                    <pre>
                        cardnumber: 4242 4242 4242 4242<br/>
                        expiry date: 10 / 20<br/>
                        CVC number: 123
                    </pre>
                    </div>
                )}

                <PricingTable highlightColor='#ed1558'>
                    <PricingSlot highlighted={onFreePlan} title='FREE' priceText='$0/month'>
                        <PricingDetail> <b>5</b> ideas</PricingDetail>
                        <PricingDetail> <b>1</b> image per idea</PricingDetail>
                        <PricingDetail> <b>1</b> sketch per idea</PricingDetail>
                        <PricingDetail> <b>1</b> attachment per idea</PricingDetail>
                        <PricingDetail> <b>1</b> user</PricingDetail>
                        <PricingDetail> <b>2</b> collaborators per idea</PricingDetail>
                        <PricingDetail strikethrough> PRE.DO <b>Power tools</b></PricingDetail>
                        <PricingDetail strikethrough> Work in teams</PricingDetail>
                        <PricingDetail strikethrough> Team Management</PricingDetail>
                        <PricingDetail strikethrough> Team Challenges</PricingDetail>
                        {onFreePlan ? (
                            <li className='grey'>
                            <Button disabled={true} bsStyle='primary'>current plan</Button>
                            </li>
                        ):(
                            <li className='grey'>
                            <Confirm
                                onConfirm={this.cancelPlan.bind(this)}
                                body='Are you sure you want to cancel your PRE.DO Single User - Paid Private - Monthly subscription? You will loose access to subscription features now, and will not be prorated for the remainder of this billing period.'
                                confirmText='Confirm Cancellation'
                                title='Cancelling PRE.DO Subscription'>
                                <Button bsStyle='link'>downgrade</Button>
                            </Confirm>                    
                            </li>
                        )}
                    </PricingSlot>
                    <PricingSlot highlighted={!onFreePlan} title='PAID PRIVATE' priceText='$4.99/month'>
                        <PricingDetail> <b>20</b> ideas</PricingDetail>
                        <PricingDetail> <b>5</b> images per idea</PricingDetail>
                        <PricingDetail> <b>5</b> sketches per idea</PricingDetail>
                        <PricingDetail> <b>5</b> attachments per idea</PricingDetail>
                        <PricingDetail> <b>1</b> user</PricingDetail>
                        <PricingDetail> <b>5</b> collaborators per idea</PricingDetail>
                        <PricingDetail strikethrough> PRE.DO <b>Power tools</b></PricingDetail>
                        <PricingDetail strikethrough> Work in teams</PricingDetail>
                        <PricingDetail strikethrough> Team Management</PricingDetail>
                        <PricingDetail strikethrough> Team Challenges</PricingDetail>
                        {!onFreePlan ? (
                            <li className='grey'>
                                <Button disabled={true} bsStyle='primary'>current plan</Button>
                            </li>
                        ):(
                            <StripeCheckout
                                name='PRE.DO ApS'
                                description='Single User - Paid Private - Monthly'
                                image='https://tool.pre.do/PRE.DO_logo.png'
                                ComponentClass='div'
                                panelLabel='Subscribe'
                                amount={499}
                                currency='USD'
                                locale='en'
                                email={user.email}
                                // Note: Enabling either address option will give the user the ability to
                                // fill out both. Addresses are sent as a second parameter in the token callback.
                                billingAddress={true}
                                // Note: enabling both zipCode checks and billing or shipping address will
                                // cause zipCheck to be pulled from billing address (set to shipping if none provided).
                                zipCode={false}
                                token={this.onToken.bind(this)}
                                allowRememberMe={true}
                                stripeKey={stripeKey}
                            >
                                <li className='grey'>
                                    <Button bsStyle='primary'>UPGRADE</Button>
                                </li>
                            </StripeCheckout>
                        )}

                    </PricingSlot>
                    <PricingSlot title='BUSINESS' priceText='DEPENDS ON TEAM SIZE'>
                        <PricingDetail> <b>unlimited</b> ideas</PricingDetail>
                        <PricingDetail> <b>unlimited</b> images per idea</PricingDetail>
                        <PricingDetail> <b>unlimited</b> sketches per idea</PricingDetail>
                        <PricingDetail> <b>unlimited</b> attachments per idea</PricingDetail>
                        <PricingDetail> <b>unlimited</b> users</PricingDetail>
                        <PricingDetail> <b>unlimited</b> collaborators per idea</PricingDetail>
                        <PricingDetail> PRE.DO <b>Power tools</b></PricingDetail>
                        <PricingDetail> Work in teams</PricingDetail>
                        <PricingDetail> Team Management</PricingDetail>
                        <PricingDetail> Team Challenges</PricingDetail>
                        <li className='grey'>
                            <Button href='mailto:support@pre.do' bsStyle='primary'>CONTACT US!</Button>
                        </li>
                    </PricingSlot>
                </PricingTable>
                <div>
                    PRE.DO <a href='http://pre.do/terms-of-service/' target='_blank' rel='noopener noreferrer'>Terms &amp; Conditions</a> and
                    &nbsp;<a href='http://pre.do/privacy-policy/' target='_blank' rel='noopener noreferrer'>Privacy Policy</a> apply to all plans.
                </div>
                <div style={{paddingBottom:100+'px'}}>
                </div>
            </div>
        )
    }
}
export default inject("stores")(observer(PlanPage))



// WEBPACK FOOTER //
// ./src/containers/PlanPage.js